export default __webpack_public_path__ + "static/media/025-sprouts.71d19e71.svg";